/* eslint-disable @typescript-eslint/naming-convention */
export enum MenuItemType {
    Contact = 'contact',
    Default = 'default',
    Inbox = 'inbox',
    Darkmode = 'darkmode_switch',
}
